/* eslint-disable no-console */
import { sendErrorAnalytics } from '../../catalog/Analytics';
import { FETCH_PHOTOS_ERROR, FETCH_PHOTO_ERROR } from '../../catalog/NotificationsComments';
import { optimXTesting } from '../../catalog/TeamInfo';
import { fetchLimitedPhotosByTagFirestoreAPI, fetchPhotoFirestoreAPI } from '../../firebase/firebaseAPICalls/FirebaseAPICallsPhoto';

export const fetchLimitedPhotosByTagAPI = async (teamId: string, tagId: string, count: number, setState: Function, snackbar: Function) => {
    const photos: any = [];
    try {
        const docs = await fetchLimitedPhotosByTagFirestoreAPI(teamId, tagId, count);
        docs.forEach((doc) => {
            if (doc.exists) {
                photos.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchPhotos', photos });
    } catch (error) {
        sendErrorAnalytics(FETCH_PHOTOS_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_PHOTOS_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchPhotoAPI = async (photoId: string, setState: Function, snackbar: Function) => {
    try {
        const doc = await fetchPhotoFirestoreAPI(photoId);
        if (doc.exists && doc.data() !== null && doc.data() !== undefined) {
            const photo = doc.data();
            setState({ type: 'fetchPhoto',
                photoTitle: photo?.title,
                photoImage: photo?.image });
        } else if (optimXTesting) {
            snackbar(FETCH_PHOTO_ERROR, { variant: 'error' });
        } else {
            sendErrorAnalytics(FETCH_PHOTO_ERROR);
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_PHOTO_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_PHOTO_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};
